import { App } from 'antd';

let modal: ReturnType<typeof App.useApp>['modal'];

export function useInitModal() {
    modal = App.useApp().modal;
}

export { modal };
